<template>
  <div class="home">
    <div>
      <video width="1300" height="600" controls>
        <source src="@/assets/vid/vid.webm" type="video/webm" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>
